import {Component, OnInit} from '@angular/core';
import {AppStateService} from "../../services/app-state.service";
import {RECHARGE_STATE_NAME} from "../../utility/recharge.state";
import {BannerConfigData} from "../../data/config-data";
import {AppRestService} from "../../services/app-rest.service";

@Component({
    selector: 'helper-section',
    templateUrl: './helper-feed.component.html',
    standalone: false
})
export class HelperFeedComponent implements OnInit {
  bannerPrefsLeft: BannerConfigData;
  bannerPrefsRight: BannerConfigData;

  amountState: boolean = false;

  constructor(private stateService: AppStateService,public restService: AppRestService) {
    this.bannerPrefsLeft=this.getBannerPrefsLeft();
    this.bannerPrefsRight= this.getBannerPrefsRight();
  }
  private getBannerPrefsLeft(): BannerConfigData {
    let bannerSrcKey = window.location.hostname.includes('test')
      ? 'banerLeftSrcTest'
      : 'banerLeftSrc';

    let bannerSrc = bannerSrcKey === 'banerLeftSrcTest'
      ? $localize`:@@banerLeftSrcTest:/assets/images/banners/cyklicznedoladowania_webp.webp`
      : $localize`:@@banerLeftSrc:/assets/images/banners/cyklicznedoladowania_webp.webp`;

    return {
      src: bannerSrc,
      link: $localize`:@@banerLeftLink:https://www.play.pl/nowy/uslugi/doladowania-cykliczne`,
      alt: $localize`:@@banerLeftAlt:Doładowania Cykliczne`
    };
  }

  private getBannerPrefsRight(): BannerConfigData {
    let bannerSrcKey = window.location.hostname.includes('test')
      ? 'banerRightSrcTest'
      : 'banerRightSrc';

    let bannerSrc = bannerSrcKey === 'banerRightSrcTest'
      ? $localize`:@@banerRightSrcTest:/assets/images/banners/banner-doladowania2.webp`
      : $localize`:@@banerRightSrc:/assets/images/banners/banner-doladowania2.webp`;

    return {
      src: bannerSrc,
        link: $localize`:@@banerRightLink:https://www.play.pl/dlaciebie/sklep/telefony/`,
        alt: $localize`:@@banerRightAlt:Smartfony 5G do 50% taniej`
    };
  }

  ngOnInit() {
    this.stateService.rechargeStateNotifier
      .subscribe(state => {
        this.amountState = (state == RECHARGE_STATE_NAME.AMOUNT);
      });
  }
  checkBanner(src: string) {
    if(src != null && src != "''"){
      return true;
    }
    else{
      return false;
    }
  }
}
